import { createContext } from 'react';

const EntityRevisionsContext = createContext({
  selectedRevisions: [],
  setSelectedRevisions: () => {},
});

export default EntityRevisionsContext;
